
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_subdomain/about/why-use-lumi",
      function () {
        return require("private-next-pages/_subdomain/about/why-use-lumi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_subdomain/about/why-use-lumi"])
      });
    }
  